module.exports = __webpack_public_path__ + "static/media/arrow-up-filled-triangle.81cdb5c4.svg";